import axiosInstance from './axiosInstance';

const ZONES_API_URL = '/zones';

class ZonesService {
  // Buscar todas as zonas de uma empresa
  async getZones(idempresa) {
    try {
      const response = await axiosInstance.get(`${ZONES_API_URL}/get.php`, {
        params: { idempresa },
        skipGlobalLoading: true
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar zonas:', error);
      throw error;
    }
  }

  // Buscar uma zona específica
  async getZone(idempresa, zoneId) {
    try {
      const response = await axiosInstance.get(`${ZONES_API_URL}/get.php`, {
        params: { idempresa, id: zoneId },
        skipGlobalLoading: true
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar zona:', error);
      throw error;
    }
  }

  // Salvar uma nova zona
  async saveZone(zoneData) {
    try {
      const response = await axiosInstance.post(`${ZONES_API_URL}/set.php`, {
        idempresa: zoneData.idempresa,
        zonas: [zoneData]
      }, {
        skipGlobalLoading: true
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar zona:', error);
      throw error;
    }
  }

  // Atualizar uma zona existente
  async updateZone(zoneData) {
    try {
      const response = await axiosInstance.post(`${ZONES_API_URL}/set.php`, {
        idempresa: zoneData.idempresa,
        zonas: [zoneData]
      }, {
        skipGlobalLoading: true
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar zona:', error);
      throw error;
    }
  }

  // Eliminar uma zona
  async deleteZone(idempresa, zoneId) {
    try {
      const response = await axiosInstance.post(`${ZONES_API_URL}/unset.php`, {
        idempresa,
        id: zoneId
      }, {
        skipGlobalLoading: true
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao eliminar zona:', error);
      throw error;
    }
  }

  // Salvar múltiplas zonas
  async saveMultipleZones(idempresa, zonesData) {
    try {
      const response = await axiosInstance.post(`${ZONES_API_URL}/set.php`, {
        idempresa,
        zonas: zonesData
      }, {
        skipGlobalLoading: true
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar múltiplas zonas:', error);
      throw error;
    }
  }

  // Eliminar múltiplas zonas
  async deleteMultipleZones(idempresa, zoneIds) {
    try {
      const results = [];
      
      // Eliminar cada zona individualmente
      for (const zoneId of zoneIds) {
        try {
          const response = await axiosInstance.post(`${ZONES_API_URL}/unset.php`, {
            idempresa,
            id: zoneId
          }, {
            skipGlobalLoading: true
          });
          results.push(response.data);
        } catch (error) {
          console.error(`Erro ao eliminar zona ${zoneId}:`, error);
          results.push({
            status: 'error',
            message: `Erro ao eliminar zona ${zoneId}`,
            zone_id: zoneId
          });
        }
      }
      
      // Verificar se todas as eliminações foram bem-sucedidas
      const successCount = results.filter(r => r.status === 'success').length;
      const errorCount = results.filter(r => r.status === 'error').length;
      
      return {
        status: errorCount === 0 ? 'success' : 'partial',
        message: `${successCount} zonas eliminadas com sucesso${errorCount > 0 ? `, ${errorCount} falharam` : ''}`,
        results: results
      };
    } catch (error) {
      console.error('Erro ao eliminar múltiplas zonas:', error);
      throw error;
    }
  }
}

export default new ZonesService();